import dayjs from 'dayjs';
import { Collapse, Container } from '@mui/material';
import { Box, Flex } from '@atoms/layout';
import { Greeting } from '@organisms/dataDisplay';
import { useAuthStore } from '@libs/store/auth';
import { useEffect } from 'react';

export function Dashboard() {
  const { userData, userDataLoading, fetchUserData } = useAuthStore();

  const loading = userDataLoading;

  useEffect(() => {
    if (!userData) {
      fetchUserData();
    }
  }, [userData]);

  return (
    <Container maxWidth={'xl'}>
      <Box pb={3}>
        <Flex justifyContent="space-between">
          <Greeting loading={loading} name={userData?.firstName ?? ''} date={dayjs()} />
        </Flex>
      </Box>
    </Container>
  );
}
